import React, { useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ErrorMessage from "../ErrorMessages/ErrorMessage";
import Image from "../images/Image";
import InputLabel from "../inputfields/InputLabel";
import InputShimmer from "../inputfields/InputShimmer";

dayjs.extend(customParseFormat);

interface CustomDatePickerProps {
  testID: string;
  label: string;
  handleStates: (date: dayjs.Dayjs | null, type: string) => void;
  value: dayjs.Dayjs | null;
  error?: string;
  disabled: boolean;
  type: "dob" | string;
  disabledDate?: boolean;
  fieldError?: boolean;
  divClassName?: string;
  id?: string;
  required: boolean;
  classType?: string;
  editLoading?: boolean;
  disabledPastDate?: boolean;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  testID,
  label,
  handleStates,
  divClassName,
  fieldError,
  value,
  error,
  disabled,
  id,
  type,
  disabledDate,
  disabledPastDate,
  required,
  classType,
  editLoading
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const getDisabledDate = (current: dayjs.Dayjs) => {
    // For disabledDate=true, disable future dates (for DOB)
    if (disabledDate) {
      return current && current > dayjs();
    }
    // For disabledPastDate=true, disable past dates (for expiry dates)
    if (disabledPastDate) {
      return current && current < dayjs().startOf('day');
    }
    // Default: no date restrictions
    return false;
  };

  return (
    <div className={divClassName}>
      <InputLabel labelName={label} id={id || 'date_label'} required={required} />
      {editLoading ? (<InputShimmer className={divClassName} />) :
        <DatePicker
          disabled={disabled}
          className={` ${disabled
            ? `custom-datepicker-disabled${classType ? `-${classType}` : ""}`
            : (error || fieldError)
              ? `custom-datepicker-error${classType ? `-${classType}` : ""}`
              : `custom-datepicker${classType ? `-${classType}` : ""}`
            } w-full py-4 pl-4 pr-4 !shadow-none focus:!shadow-none`}
          autoComplete="off"
          data-testid={testID ||id}
          placeholder={'Select date'}
          format={"DD MMM YYYY"}
          value={value}
          suffixIcon={<Image src="calendar" />}
          disabledDate={getDisabledDate}
          onChange={(date) => handleStates(date, type)}
          onClick={() => setIsFocused(true)}
          getPopupContainer={(trigger) => trigger.parentElement || document.body}
          popupStyle={{ 
            position: 'fixed',
            zIndex: 1050,
          }}
        />
      }
      {error && (
        <ErrorMessage testId='error-msg' errorMessage={error || ''} />
      )}
    </div>
  );
};

export default CustomDatePicker;